import { Component } from '@angular/core';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { differenceInBusinessDays } from 'date-fns';
import { Router } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-mail-server',
  standalone: true,
  imports: [],
  templateUrl: './mail-server.component.html',
  styleUrl: './mail-server.component.scss'
})
export class MailServerComponent {
    dbmessage:string='';

  copiedEmail:string=''
  apiData$: any;
copyToClipboard(value: any) {
  navigator.clipboard.writeText(value);
  this.copiedEmail=value;
}
  allMailsArrayTemp:any[]=[];
  allMailsArray:any[]=[];
  mailInfoArray:any;
  type:string='otp';
  constructor(private restService :MemberInsurerRestService,private Notificationservice:NotificationService,private route :Router ,private memberservice:MemberInsurerServiceService){}

  ngOnInit(){
    this.getallMails()
    // this.openEmail(this.allMailsArrayTemp[0]?.id)
  this.memberservice.refreshotp$.subscribe((value)=>{
    console.log(value)
    this.getallMails();
  })
 
    
    

   
  }

  getallMails(){
     this.restService.getAllMails().subscribe({
      next:(response)=>{
        console.log(response);
        this.allMailsArrayTemp=response;
        
       this.formatTime(response.time);

      },
      error:(err)=>{
        console.log(err);
        this.Notificationservice.showNotification(err.message)

      }

    })

  }

  formatTime(time:any){
    const date =new Date()
    const receivedDate = new Date(time)
    console.log(date);
    console.log(receivedDate)

    const difference = date.getMinutes()-receivedDate.getMinutes()
    console.log(difference);
    this.allMailsArrayTemp.forEach((item)=>{

      item.time=new Date().getMinutes()-new Date(item.time).getMinutes();
    }
    

    )

    console.log(this.allMailsArrayTemp)
    return difference;

  }

  openEmail(id:any){
    this.restService.getAllMailsById(id).subscribe({
      next:(response)=>{
        this.mailInfoArray=response;
        console.log(this.mailInfoArray)
      this.dbmessage=this.mailInfoArray?.message;

      },
      error:(err)=>{
        console.log(err)
        this.Notificationservice.showNotification(err.message)
      }
    })

  }

  renerRespective(link:any){
    console.log(link);
   console.log( `http://localhost:4200${link.slice(35,)}`)
    this.route.navigateByUrl(`http://localhost:4200${link.slice(35,)}`)

  }

}
